// All theme colors centralized here for usage with Next.js + Turbopack

// Slightly tinted instead of plain white so surfaces pick up the brand hue
const PAPER = '#f9fbfd';

export const colors = {
    // paper & background
    paper: PAPER,

    // surface layers: tinted canvas below, lighter tinted cards above
    canvas: '#edf3f8',
    surface: PAPER,
    surfaceSubtle: '#f5f9fc',
    surfaceBorder: 'rgba(26, 86, 136, 0.10)',
    sidebar: 'color-mix(in srgb, #5fa0d2 70%, #3f494b)',

    // primary (Connex Blue)
    primaryUltraLight: '#f7f9fa',
    primaryLight: '#bdd4ec',
    primaryMain: '#5fa0d2', // Main blue color
    primaryDark: '#1a5688',
    primary200: '#2378bd',
    primary800: '#144267',

    // secondary (Connex Teal)
    secondaryBgPinkHover: '#d4f4ee',
    secondaryBgPink: '#bdf0e7',
    secondaryBgPinkDark: '#a5ebdf',
    secondaryLight: '#7fdccf',
    secondaryMain: '#14b99c',
    secondaryDark: '#0e8a74',
    secondary200: '#4ad2bb',
    secondary800: '#0b6a59',

    // bot card tints (lightened secondary teal & primary blue)
    botCardSurface: '#fbfefe',
    botCardSurfaceHover: '#f1fbf9',
    botCardBorder: '#dcf3ef',
    botCardPink: '#e6f8f4',
    botCardRose: '#e3f3f5',
    botCardLilac: '#e7f1f9',
    botCardViolet: '#dde9f6',
    botCardAccent: '#0e8a74',
    botCardPinkDark: '#4aa392',

    // campaign calls result
    summaryPending: 'rgb(198, 198, 198)',
    summaryInitiated: 'rgb(225, 203, 107)',
    summaryDenied: 'rgb(255, 163, 50)',
    summaryToRetry:
        'repeating-linear-gradient(-45deg, white, white 1px, rgb(255, 163, 50) 1px, rgb(255, 163, 50) 10px)',
    summaryUnconnected: 'rgb(231, 76, 128)',
    summaryFinished: 'rgb(49, 139, 70)',

    // success
    successLight: '#b9f6ca',
    success200: '#69f0ae',
    successMain: '#00e676',
    successDark: '#00c853',

    // error
    errorLight: '#ef9a9a',
    errorMain: '#f44336',
    errorDark: '#c62828',

    // orange
    orangeLight: '#fbe9e7',
    orangeMain: '#ffab91',
    orangeDark: '#d84315',

    // warning
    warningLight: '#fff8e1',
    warningMain: '#ffe57f',
    warningDark: '#ffc107',

    // grey (Connex neutrals)
    grey50: '#fdfefe',
    grey100: '#c5d7d8',
    grey200: '#b0c4c6',
    grey300: '#8e9ea2',
    grey500: '#6b7a7d',
    grey600: '#556063',
    grey700: '#3f494b',
    grey900: '#1d2223',

    // ==============================|| DARK THEME VARIANTS ||============================== //

    // paper & background
    darkBackground: '#121415',
    darkPaper: '#0d0f10',

    // dark 800 & 900
    darkLevel1: '#1d2223',
    darkLevel2: '#2a3032',

    // primary dark (blue-focused)
    darkPrimaryLight: '#bdd4ec',
    darkPrimaryMain: '#2378bd',
    darkPrimaryDark: '#1a5688',
    darkPrimary200: '#5fa0d2',
    darkPrimary800: '#144267',

    // secondary dark (teal-focused)
    darkSecondaryLight: '#7fdccf',
    darkSecondaryMain: '#14b99c',
    darkSecondaryDark: '#0e8a74',
    darkSecondary200: '#4ad2bb',
    darkSecondary800: '#0b6a59',

    // text variants
    darkTextTitle: '#c5d7d8',
    darkTextPrimary: '#8e9ea2',
    darkTextSecondary: '#6b7a7d',
};

export default colors;
